import React from 'react';
import MarkdownLayout from '../../Layout/MarkdownLayout';

const CookiePolicyContainer = () => {
    return <MarkdownLayout title={'Cookie Policy'} mdFileName={'CookiePolicy'} />;
};

export default CookiePolicyContainer;
